import { render } from "./QiuckView.vue?vue&type=template&id=1e38a03b&scoped=true"
import script from "./QiuckView.vue?vue&type=script&lang=js"
export * from "./QiuckView.vue?vue&type=script&lang=js"

import "./QiuckView.vue?vue&type=style&index=0&id=1e38a03b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e38a03b"]])

export default __exports__